import styled from 'styled-components';
import device from '../../../GlobalDigitalStyle/BreakPoint.style';

export const HomeSectionWrapper = styled.div`
	.section-header {
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
		margin-bottom: 0.5em;
		.section-title {
			font-family: 'Manrope-Bold';
			color: #000;
			font-weight: 700;
			font-size: 18px;
			@media ${device.screen1680} {
				font-size: 16px;
			}
			@media ${device.screen1280} {
				font-size: 14.8px;
			}
			@media ${device.screen1050} {
				font-size: 13px;
			}
		}
		.section-nav {
			i {
				font-size: 0.7rem;
				@media (max-width: 1450px) {
					font-size: 0.5rem;
				}
				color: #afafaf !important;
			}
			p {
				margin: 0;
				font-family: 'Manrope-Bold';
				font-size: 0.9rem;
				color: #afafaf;
				@media (max-width: 1450px) {
					font-size: 0.7rem;
				}
			}
		}
	}
	.text__default {
		font-weight: 600;
		font-size: 15px;
		@media ${device.screen1680} {
			font-size: 14px;
		}
		@media ${device.screen1280} {
			font-size: 12.8px;
		}
		@media ${device.screen1050} {
			font-size: 11px;
		}
	}
`;

export const HomeSectionContainer = styled.div`
	/* border: 1px solid #0000001a; */
	border-radius: 24px;
	width: 100%;
	overflow: hidden;
`;
